import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-curtain', 'showLess', 'Rādīt mazāk');
Labels.set('ui-curtain', 'showMore', 'Parādīt vairāk');
Labels.set('ui-curtain', 'completedStep', 'Pabeigts solis');
